import * as React from 'react'

export function SettingsDevices(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M22 14c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1H10c-.55 0-1-.45-1-1V15c0-.55.45-1 1-1h12zm-4 10v-6c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1zm-1.5-3c.275 0 .5.225.5.5v2c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-2c0-.275.225-.5.5-.5h1zm7.69-13.725a1.001 1.001 0 01-1.38 1.449A9.845 9.845 0 0016 6a9.846 9.846 0 00-6.81 2.724 1 1 0 11-1.38-1.449A11.843 11.843 0 0116 4c3.058 0 5.966 1.163 8.19 3.275zM11.7 11.713a.996.996 0 01-1.414-.013.999.999 0 01.014-1.414C11.782 8.832 13.86 8 16 8c2.231 0 4.261.816 5.714 2.3a1 1 0 11-1.428 1.4C19.212 10.604 17.69 10 16 10c-1.597 0-3.205.64-4.3 1.713z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
